import { render } from "./FarmerDashTotalsChart.vue?vue&type=template&id=c17672f8"
import script from "./FarmerDashTotalsChart.vue?vue&type=script&lang=js"
export * from "./FarmerDashTotalsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__